/** Guru whitelabel theme entry. */

import type { WhitelabelThemeEntry } from '../../types';
import { pblcrEstDefaultTheme } from './default';

export { pblcrEstWhitelabel } from './default';

export const pblcrEstWhitelabelThemeEntry: WhitelabelThemeEntry = {
  themes: {
    default: pblcrEstDefaultTheme,
  },
};
